module.exports = __webpack_public_path__ + "75be7e03cdf46b39360fee459a2960a7.svg";